import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {UIButtonKey, uiElementsStatesMap} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStatesMap';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';
import {UIStateName} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStatesMap';

export class UIElementsStatesService extends UiServiceV2 {
    public static NAME = 'UIElementsStatesService';

    public onSetupEvents(): void {
        this.emitter.on('UI.updateUIElementsState', this.onUpdateUIElementsState.bind(this));
    }

    private onUpdateUIElementsState(state: UIStateName) {
        const newState = uiElementsStatesMap[state];

        (Object.keys(newState) as UIButtonKey[]).forEach(value => {
            uiElementsStore[value].value = newState[value];
        });
    }
}